import React, { useState, useEffect } from 'react'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import Badge from '@material-ui/core/Badge'
import classnames from 'classnames'
import { makeStyles } from '@material-ui/core'
import { useHistory } from 'react-router-dom';

const DMTabContainer = ({tabs, alignment, defaultActiveTab, onTabChange, inactiveClassname = null, divisonLineClassname = null}) => {
    
    const TabStyles = makeStyles(() => ({
        tabContainer: {
            display: 'flex',
            height: '48px'
        },
        alignCenter:{
            justifyContent: 'center'
        },
        alignLeft:{
            justifyContent:'left'
        },
        activeTabIndicator: {
            backgroundColor: '#1891F6',
            height: '4px',
        },
        tabLabels: {
            textTransform: 'initial',
            fontStyle: 'normal',
            fontSize: '16px',
            lineHeight: '19px',
            marginBottom: '-10px',
        },
        activeLabel: {
            color: '#1891F6',
            fontWeight: 'bold',
        },
        inActiveLabel: {
              color: '#BAC0D0',
            fontWeight: 'normal',
        },
        tabRoot: {
            padding: '0px',
            minWidth: 'fit-content',
            marginRight: '30px',
        },
        divisionLine: {
            borderBottom: '1px solid #E5E7ED',
        },
        negativeMargin: {
            marginTop: '-1px',
        },
        badgePadding: {
            paddingRight: '12px',
        },
        badgeContent: {
            width: '10px',
            minWidth: '10px',
            height: '10px',
            fontSize: '0.5rem',
            fontWeight: 'bold',
            lineHeight: '8px',
            padding: '0 3px',
            color: '#FFFFFF',
            right: '-5px',
            backgroundColor: '#1891F6',
        },
    }))
    const classes = TabStyles()
    const [activeTab, setActiveTab] = useState(defaultActiveTab || 0)
    const history = useHistory();
    
    const handleTabChange = (event,activeTab) => {
        console.log('checking DMT',tabs[activeTab]);
        const linkRoute = event.target.innerText.toLowerCase();
        history.push(`/${tabs[activeTab].path}`);
        setActiveTab(activeTab)
        onTabChange(activeTab)
    }

    useEffect(() => {
        setActiveTab(defaultActiveTab)
    }, [defaultActiveTab])

    const getLabel = (tab, index) => {
        return (
            <span
                className={`${classes.tabLabels} ${
                    activeTab === index ? classes.activeLabel : classnames(inactiveClassname, classes.inActiveLabel)
                }`}>
                {tab.name}
            </span>
        )
    }

    return (
        <div className={`${classes.tabContainer} ${alignment === 'center' ? classes.alignCenter : classes.alignLeft}`}>
            <Tabs
                onChange={handleTabChange}
                value={activeTab}
                classes={{
                    indicator: classes.activeTabIndicator,
                    fixed: classes.greyBotoomBorder,
                }}>
                {tabs.map((tab, index) => {
                    return (
                        <Tab
                            key={index}
                            id={`Tab_${index}`}
                            aria-controls='simple-tabpanel'
                            classes={{
                                root: classnames(classes.tabRoot, tab.badgeContent && classes.badgePadding),
                            }}
                            disabled={tab.disabled || false}
                            label={
                                tab.badgeContent ? (
                                    <Badge
                                        classes={{ colorPrimary: classes.badgeContent }}
                                        badgeContent={tab.badgeContent}
                                        color='primary'>
                                        {getLabel(tab, index)}
                                    </Badge>
                                ) : (
                                    getLabel(tab, index)
                                )
                            }
                        />
                    )
                })}
            </Tabs>
            <div className={classnames(divisonLineClassname, classes.divisionLine, classes.negativeMargin)} />
        </div>
    )
}

export default DMTabContainer
